module.exports = __webpack_public_path__ + "img/fin-balance1.57e425bb.jpg";